import { useState } from 'react';

export const useShapeActions = () => {
  const [shapes, setShapes] = useState<unknown[]>([]);

  const handleDelete = (key: string) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    setShapes(prevShapes => prevShapes.filter(shape => (shape as Record<string, unknown>)['key'] !== key));
  };

  const handleEdit = (key: string, newShapeData: unknown) => {
    setShapes(prevShapes =>
      prevShapes.map(shape =>
        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
        (shape as Record<string, unknown>)['key'] === key
          ? { ...(shape as Record<string, unknown>), ...(newShapeData as Record<string, unknown>) } // eslint-disable-line @typescript-eslint/no-unsafe-type-assertion
          : shape,
      ),
    );
  };

  return { shapes, handleDelete, handleEdit };
};

export const clampYToChart = (
  pointerChartId: unknown,
  startChartId: unknown,
  chartConfigs: unknown[] | undefined,
  chartOrder: unknown[],
  y: number,
): number => {
  if (pointerChartId === startChartId) return y;

  const configs = chartConfigs ?? [];
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  const config = configs.find(c => (c as Record<string, unknown>)['id'] === startChartId) as
    | Record<string, unknown>
    | undefined;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  const domain = config?.['realYDomain'] as [number, number] | undefined;
  if (!domain) return y;

  const [minY, maxY] = domain;

  return chartOrder.indexOf(pointerChartId) > chartOrder.indexOf(startChartId) ? minY : maxY;
};

export const clamp = (value: number, min: number, max: number) => Math.max(min, Math.min(max, value));

export const isPoint = (p: unknown): p is [number, number] =>
  Array.isArray(p) && p.length === 2 && typeof p[0] === 'number' && typeof p[1] === 'number';
